/*
Controller: BulkImport

Operations:
  importBinaries
  bulkImportResult
*/
var Api = require('../config')
var TempImportVersionDef = require('../definitions/TempImportVersion')

var BulkImport = (function () {
  /*
  Operation: importBinaries
  Upload font binaries in bulk
  Parameters:

  Responses:
    HTTP 200: Successful upload
    HTTP 400: Upload failed. This could be due to file format issues, file size etc.
    HTTP 403: Operation not permitted
    HTTP 409: File has already been uploaded
    HTTP 413: Uploaded file too large
    HTTP 415: Wrong file type
  */
  function importBinariesBulkImport (file) {
    return new Promise(function (resolve, reject) {
      try {
        if (!file) {
          throw new Error('file: Missing parameter')
        }
        if (file && !(typeof file === 'object')) {
          throw new Error('file: Wrong type: Got "' + (typeof file) + '", but expected: "object"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = new FormData()
      parameters.append('file', file)
      var path = '/bulkImport'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: bulkImportResult
  Get Result of Bulk Import
  Parameters:
    bodyRequest: TempImportVersion
  Responses:
    HTTP 200: Valid response
    HTTP 400: Import Status API failed
    HTTP 404: TempImportVersion Not Found
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function bulkImportResultBulkImport (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        TempImportVersionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/getBulkImportResult'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['importBinaries'] = importBinariesBulkImport
  ret['bulkImportResult'] = bulkImportResultBulkImport
  return ret
})()

module.exports = BulkImport
